import Vue from 'vue';

Vue.component('cancelled-order', () =>
    import(/* webpackChunkName: 'cancelled-order' */ './cancelled-order.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/cancelled-order/index.js